import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as formActions } from 'react-redux-form';
import actions from 'actions/initialActions';
import focusActions from 'actions/focusActions';
import preLoaderActions from 'actions/preLoaderActions';
import productsActions from 'actions/productsActions';
import scoringActions from 'actions/scoringActions';
import { InitialStepFormComponent } from './InitialStepFormComponent';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
import { withCaptcha } from 'hocs/withCaptcha/withCaptcha';

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        extraData: state.extraData,
        userProfileForm: state.userProfileForm,
        focus: state.focus,
        preLoader: state.preLoader,
        initialStep: state.initialStep,
        immStepsState: state.steps,
        products: state.products,
        wealthProduct: state.wealthProduct,
    };
};

const mapDispatchToProps = dispatch => ({
    formActions: bindActionCreators(formActions, dispatch),
    actions: bindActionCreators(actions, dispatch),
    focusActions: bindActionCreators(focusActions, dispatch),
    preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    productsActions: bindActionCreators(productsActions, dispatch),
    scoringActions: bindActionCreators(scoringActions, dispatch),
});

export const InitialStepForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(withCaptcha(withFeatureToggling(InitialStepFormComponent)));
